import { setupCanvas } from './setupCanvas';

export const createAnimation = (initialize, update, draw) => canvas => {
    let raf;
    let data = null;
    let initialized = false;
    const ctx = canvas.getContext('2d');
    let { width, height } = setupCanvas(canvas);

    const invokeDraw = () => draw(ctx, data, width, height);

    const loop = () => {
        data = update(data, width, height);
        invokeDraw();
        raf = requestAnimationFrame(loop);
    };

    const resize = () => {
        const dimensions = setupCanvas(canvas);
        width = dimensions.width;
        height = dimensions.height;
        raf = requestAnimationFrame(invokeDraw);
    };

    const start = () => {
        if (!initialized) {
            initialized = true;
            data = initialize(width, height);
        }
        raf = requestAnimationFrame(loop);
    };

    const stop = () => cancelAnimationFrame(raf);

    return {
        resize,
        start,
        stop
    };
};
